export const search = {
  CanadaLink: "Canada link",
  USALink: "USA Link",
  LandingPageTitle: "Total dispensing freedom.",
  LandingPageDescription:
    "Our industry-leading catalog features top supplement brands available for you to recommend in-office or virtually to your patients.",

  // title and meta tags
  title: "Fullscript's Dispensing Catalog",
  metaDescription:
    "Prescribe virtually or shop from over 300 professional quality supplement brands for in-office dispensing all in one place.",
} as const;
